export default __webpack_public_path__ + "static/media/share.75b0adb6.svg";